import React from "react";
import StarReview from "../common/StarReview";
import styles from "../../_css/Home.module.css";

function ReviewCard({ ratings, review, name }) {
  return (
    <div className={styles.reviewCard}>
      <StarReview rating={ratings} size={16} padding="2px" />
      <p className="mt-2">{review}</p>
      <div className={styles.reviewCardProfile}>
        <img
          src={`${process.env.REACT_APP_PROJECT_URL}/img/square-static-img.png`}
          alt="profile"
          width={24}
          height={24}
        />
        <h6>{name}</h6>
      </div>
    </div>
  );
}

export default ReviewCard;
